import TabellaPagamentiCertificatoView from "./TabellaPagamentiCertificatoView";

export default function TabellaPagamentiCertificatoController({
                                                       certificato,
                                                   }) {

    return (
        <TabellaPagamentiCertificatoView
            certificato={certificato}
        />
    );
}